import React, { useState } from "react";
import TimeAgo from "react-timeago";
import get from "lodash/get";
import PropTypes from "prop-types";
import { SvgHandler } from "../svg-handler/svg-handler";
import clockIcon from "../../../assets/icons/clock.svg";
import "./live-blog-key-events.module.css";
import downArrowIcon from "../../../assets/icons/down-arrow.svg";
import { breakpoint } from "../../../utils/breakpoint";
import format from "date-fns/format";

function dateFormatter(value, unit, suffix, date) {
  return format(new Date(date), "HH:mm, DD MMM YYYY");
}
const FetchEventTitle = props => {
  return (
    <div>
      {props.elements.map(
        (element, index) =>
          element.type === "title" && (
            <h3 data-testid="event-title" styleName="event-title" key={index}>
              {element.text}
            </h3>
          )
      )}
    </div>
  );
};
FetchEventTitle.propTypes = {
  elements: PropTypes.array
};

function KeyEvent(props) {
  return (
    <article data-testid="key-events" styleName="key-events-wrapper">
      <div>
        <div styleName="key-clock-wrapper clock-wrapper-key">
          <div styleName="key-event-clock">
            <SvgHandler width="16px" height="16px" xlinkHref={clockIcon} />
          </div>
          <TimeAgo
            date={props.card["card-added-at"]}
            formatter={dateFormatter}
            title={null}
            styleName="cards-added-at"
          />
        </div>
        <a href={`/${props.slug}#${props.card.id}`}>
          <FetchEventTitle elements={props.card["story-elements"]} />
        </a>
      </div>
    </article>
  );
}
KeyEvent.propTypes = {
  card: PropTypes.object,
  config: PropTypes.object,
  slug: PropTypes.string
};
function LiveBlogKeyEvents(props) {
  const liveBlog = get(props, ["config", "theme-attributes", "live-blog"], "default");
  const cards = get(props, ["story", "cards"], []);
  const [showKeyEvent, toggleKeyEventsWidget] = useState(false);
  const cardsWithKeyEvents = cards.filter(card => get(card.metadata, ["attributes", "key-event"]));
  if (cardsWithKeyEvents.length < 1) {
    return null;
  }
  const keyEvents = cardsWithKeyEvents.map(card => <KeyEvent card={card} key={card.id} slug={props.story.slug} />);
  const svgStyle = showKeyEvent ? "close" : "";
  const liveBlogTemplates = {
    "hero-priority": true,
    "headline-priority": false,
    "headline-hero-priority": true,
    "headline-sideway": true,
    "hero-overlay": true,
    default: false
  };
  const keyEventDesktop = liveBlogTemplates[liveBlog] ? showKeyEvent && keyEvents : keyEvents;
  const eventStyles = liveBlogTemplates[liveBlog] === true ? "event-styles-wrapper" : "";
  return (
    <div styleName="events">
      <div styleName={`key-events ${eventStyles}`}>
        <div styleName="heading" onClick={() => toggleKeyEventsWidget(!showKeyEvent)}>
          key events
          <span styleName={`svg-wrapper ${svgStyle}`}>
            <SvgHandler width="24px" height="24px" xlinkHref={downArrowIcon} />
          </span>
        </div>
        {!breakpoint("tablet") ? keyEventDesktop : showKeyEvent && keyEvents}
      </div>
    </div>
  );
}
LiveBlogKeyEvents.propTypes = {
  story: PropTypes.object
};

export { LiveBlogKeyEvents };
